import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100vw;
  height: calc(100dvh - 30px);
  overflow: hidden;

  area {
    outline-color: white;
  }

  .underlay {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &#lobby {
      .landscape {
        display: block;
      }
    }

    .bg-img {
      position: absolute;
      inset: 0;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: fill;
      pointer-events: none;
    }
  }
`

export default function PageWithBg({
  children,
  bgImg,
  avoidNavOverlap = false,
}) {
  return (
    <Wrapper avoidNavOverlap={avoidNavOverlap}>
      <div id='others' className="underlay">
        <img className="bg-img landscape" src={bgImg} alt="Page Background" useMap="#bg"/>
        {children}
      </div>
    </Wrapper>
  )
}
